import { Spinner } from '@/components/ui/Spinner'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { Box, Text } from '@chakra-ui/react'

/**
 * Superadmin Route Component
 * Only allows access for superadmin users
 */
export function SuperadminRoute({ children }) {
  const { user, isLoading } = useAuth()

  // Show loading spinner while checking auth
  if (isLoading) {
    return <Spinner fullScreen />
  }

  // Check if user is superadmin
  if (!user?.is_superuser) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minH="60vh"
        p={6}
      >
        <Box
          bg="#FFEBE6"
          p={6}
          borderRadius="6px"
          border="1px solid #FF5630"
          maxW="500px"
          textAlign="center"
        >
          <Text fontSize="18px" fontWeight="600" color="#BF2600" mb={2}>
            Access Denied
          </Text>
          <Text fontSize="14px" color="#5E6C84">
            You do not have permission to access this page. Only superadmins can view user management.
          </Text>
        </Box>
      </Box>
    )
  }

  return children
}

export default SuperadminRoute
